{
  "brand": {
    "name": "Sigma08",
    "tagline": "Plataforma de Aprendizaje con IA",
    "description": "Transforma la educación con experiencias de aprendizaje personalizadas con IA"
  },
  "actions": {
    "submit": "Enviar",
    "cancel": "Cancelar",
    "save": "Guardar",
    "delete": "Eliminar",
    "edit": "Editar",
    "view": "Ver",
    "download": "Descargar",
    "upload": "Subir",
    "search": "Buscar",
    "filter": "Filtrar",
    "sort": "Ordenar",
    "refresh": "Actualizar",
    "back": "Atrás",
    "next": "Siguiente",
    "previous": "Anterior",
    "close": "Cerrar",
    "confirm": "Confirmar",
    "retry": "Reintentar",
    "loading": "Cargando...",
    "processing": "Procesando..."
  },
  "status": {
    "success": "Éxito",
    "error": "Error",
    "warning": "Advertencia",
    "info": "Información",
    "pending": "Pendiente",
    "active": "Activo",
    "inactive": "Inactivo",
    "completed": "Completado",
    "failed": "Fallido",
    "cancelled": "Cancelado"
  },
  "time": {
    "today": "Hoy",
    "yesterday": "Ayer",
    "tomorrow": "Mañana",
    "thisWeek": "Esta Semana",
    "lastWeek": "Semana Pasada",
    "thisMonth": "Este Mes",
    "lastMonth": "Mes Pasado",
    "thisYear": "Este Año",
    "lastYear": "Año Pasado",
    "seconds": "segundos",
    "minutes": "minutos",
    "hours": "horas",
    "days": "días",
    "weeks": "semanas",
    "months": "meses",
    "years": "años"
  },
  "pagination": {
    "page": "Página",
    "of": "de",
    "items": "elementos",
    "showing": "Mostrando",
    "to": "a",
    "perPage": "Por página",
    "goToPage": "Ir a la página"
  },
  "currency": {
    "symbol": "€",
    "code": "EUR"
  },
  "language": {
    "select": "Seleccionar Idioma",
    "current": "Español",
    "switch": "Cambiar a Português"
  },
  "region": {
    "select": "Seleccionar Región",
    "current": "España",
    "switch": "Cambiar Región"
  }
}
